import DropzoneElement from "../components/Dropzone/DropzoneElement";
import DropzoneInput from "../components/Dropzone/DropzoneInput";
import ImagesGrid from "../components/Dropzone/ImagesGrid";
import React, { useState, useEffect } from "react";

import "../assets/style/product/variant-card.scss";
import ClipLoader from "react-spinners/ClipLoader";
import { FileUploadPromise } from "../utils/aws_s3/aws_s3";
import { useParams } from "react-router-dom";
import {
  set_deleted_images,
  set_variants,
} from "../redux/actions/ProductsAction";
import { connect } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getClass, IsQuillEmpty } from "../utils/utils";
import Resizer from "react-image-file-resizer";

import { toast } from "react-toastify";
import { type } from "../components/Dropzone/type";
import Switch from "@material-ui/core/Switch";
import RSelect from "react-select";
import { Box, Button, FormControlLabel, IconButton } from "@material-ui/core";

function VariantCard(props) {
  const { state } = useParams();

  const [openImagesGrid, setOpenImagesGrid] = useState(
    props.variant ? true : false,
  );
  const [uploadingImages, setUploadingImages] = useState(false);
  const [show, setShow] = useState(state === "view");
  const [uploadingSingleImage, setUploadingSingleImage] = useState(false);
  const [loading, setLoading] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const resizeFileForDesktop = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        250,
        250,
        "png",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob",
      );
    });
  const resizeFileForMob = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        100,
        100,
        "png",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob",
      );
    });

  const handleFilesChange = (files) => {
    let fileUploadPromises = [];
    setUploadingImages(true);

    files.forEach((file) => {
      fileUploadPromises.push(FileUploadPromise(file));
    });

    Promise.all(fileUploadPromises)
      .then((response) => {
        setUploadingImages(false);
        props.variant.images && Array.isArray(props.variant.images)
          ? props.set_variants(
              props.variants.map((variant) =>
                variant.id === props.variant.id
                  ? {
                      ...variant,
                      images: [
                        ...props.variant.images,
                        ...response.map((image) => image.location),
                      ],
                    }
                  : variant,
              ),
            )
          : props.set_variants(
              props.variants.map((variant) =>
                variant.id === props.variant.id
                  ? {
                      ...variant,
                      images: [...response.map((image) => image.location)],
                    }
                  : variant,
              ),
            );
        setOpenImagesGrid(true);
      })
      .catch((err) => {
        setUploadingImages(false);
        message = "File upload error";
        showError();
      });
  };

  const handleSingleFileChange = async (files) => {
    let fileUploadPromises = [];
    setUploadingSingleImage(true);
    const resizeImageDesktop = await resizeFileForDesktop(files[0]);
    const resizeImageMob = await resizeFileForMob(files[0]);

    files.push(resizeImageMob);
    files.push(resizeImageDesktop);

    files.forEach((file) => {
      fileUploadPromises.push(FileUploadPromise(file));
    });

    Promise.all(fileUploadPromises)
      .then((response) => {
        setUploadingSingleImage(false);
        props.set_variants(
          props.variants.map((variant) =>
            variant.id === props.variant.id
              ? {
                  ...variant,
                  featured_image: response[0].location,
                  featured_image_resized: [
                    response[1].location,
                    response[2].location,
                  ],
                }
              : variant,
          ),
        );
        setOpenImagesGrid(true);
      })
      .catch((err) => {
        setUploadingSingleImage(false);
        message = "File upload error";
        showError();
      });
  };

  useEffect(() => setShow(state === "view"), [state]);
  useEffect(() => {
    if (
      props.selected === props.variant.id &&
      props.variants[0].id !== props.selected
    ) {
      document.getElementById(`${props.selected}`)?.scrollIntoView();
    }
    // eslint-disable-next-line
  }, [props.selected]);

  const placements = [
    { value: "floor", label: "Floor" },
    { value: "wall", label: "Wall" },
  ];

  const isEditMode = state !== "view";
  return (
    <div
      id={props.variant.id}
      // className={`variant-card-desktop row g-0 mt-4 ${
      //   !(
      //     typeof props.variant?.id === "string" ||
      //     props.selected === props.variant.id ||
      //     (props.variant.showError && isEditMode)
      //   )
      //     ? "pointer collapse-card"
      //     : ""
      // }`}
      className="variant-card"
      onClick={() => {
        if (
          !(
            typeof props.variant?.id === "string" ||
            props.selected === props.variant.id
          )
        ) {
          props.onUpdateVar(props.variant.id);
        }
      }}
    >
      <Box display="flex" alignContent="center" justifyContent="space-between">
        <h3 className="title">
          {`
      Variant ${props.index} ${props.variant.name_en && "(" + props.variant.name_en + ")"}
        `}
        </h3>

        {isEditMode && (
          <IconButton
            color="danger"
            style={{
              width: 36,
              height: 36,
              background: "red",
              padding: 0,
              borderRadius: 6,
              marginBottom: 12,
            }}
            onClick={(e) => {
              e.stopPropagation();

              if (
                window.confirm("Are you sure you want to delete this variant?")
              ) {
                props.onUpdate(props.variant.id);
              }
            }}
          >
            <AiOutlineDelete size={20} color="white" />
          </IconButton>
        )}
      </Box>

      <div className="grid">
        {/* First Column */}
        <div className="col">
          {/* Name */}
          <div className="row">
            <div className="input half">
              <label>Name*</label>
              <input
                placeholder="Enter name"
                type="text"
                value={props.variant.name_en}
                disabled={show}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, name_en: e.target.value }
                        : variant,
                    ),
                  )
                }
              />
              {props.variant.showError && props.variant.name_en.length < 1 && (
                <div className="error">Required</div>
              )}
            </div>
            <div className="input half">
              <label>اسم</label>
              <input
                placeholder="أدخل الاسم"
                type="text"
                value={props.variant.name_ar}
                name="name_ar"
                disabled={show}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, name_ar: e.target.value }
                        : variant,
                    ),
                  )
                }
              />
            </div>
          </div>

          {/* Discription */}
          <div className="row">
            <div className="input half">
              <label>Description*</label>
              <CKEditor
                className={getClass(
                  props.variant?.showError &&
                    props.variant?.description_en?.length < 1,
                )}
                editor={ClassicEditor}
                data={
                  props.variant?.description_en
                    ? props.variant?.description_en
                    : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            description_en: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />

              {props.variant.showError &&
                (props.variant.description_en
                  ? props.variant.description_en.length < 1
                  : true) && <div className="error">Required</div>}
            </div>
            <div className="input half">
              <label>وصف</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  props.variant?.description_ar
                    ? props.variant?.description_ar
                    : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            description_ar: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
            </div>
          </div>

          {/* Benifits */}
          <div className="row">
            <div className="input half">
              <label>Benefits*</label>
              <CKEditor
                className={getClass(
                  props.variant?.showError &&
                    props.variant?.benefits_en?.length < 1,
                )}
                editor={ClassicEditor}
                data={
                  props.variant?.benefits_en ? props.variant?.benefits_en : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            benefits_en: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
              {props.variant.showError &&
                (props.variant.benefits_en
                  ? props.variant.benefits_en.length < 1
                  : true) && <div className="error">Required</div>}
            </div>

            <div className="input half">
              <label>فوائد</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  props.variant?.benefits_ar ? props.variant?.benefits_ar : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            benefits_ar: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
            </div>
          </div>

          {/* Features */}
          <div className="row">
            <div className="input half">
              <label>Features*</label>
              <CKEditor
                className={getClass(
                  props.variant?.showError &&
                    props.variant?.features_en?.length < 1,
                )}
                editor={ClassicEditor}
                data={
                  props.variant?.features_en ? props.variant?.features_en : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            features_en: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
              {props.variant.showError &&
                (props.variant.features_en
                  ? props.variant.features_en.length < 1
                  : true) && <div className="error">Required</div>}
            </div>
            <div className="input half">
              <label>سمات</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  props.variant?.features_ar ? props.variant?.features_ar : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            features_ar: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
            </div>
          </div>

          {/* How To Use */}
          <div className="row">
            <div className="input half">
              <label>How to use*</label>
              <CKEditor
                className={getClass(
                  props.variant?.showError &&
                    props.variant?.how_to_use_en?.length < 1,
                )}
                editor={ClassicEditor}
                data={
                  props.variant?.how_to_use_en
                    ? props.variant?.how_to_use_en
                    : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            how_to_use_en: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
              {props.variant.showError &&
                (props.variant.how_to_use_en
                  ? props.variant.how_to_use_en.length < 1
                  : true) && <div className="error">Required</div>}
            </div>
            <div className="input half">
              <label>كيف تستعمل</label>
              <CKEditor
                editor={ClassicEditor}
                data={
                  props.variant?.how_to_use_ar
                    ? props.variant?.how_to_use_ar
                    : ""
                }
                disabled={show}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? {
                            ...variant,
                            how_to_use_ar: data,
                          }
                        : variant,
                    ),
                  );
                }}
              />
            </div>
          </div>

          {/* Wholse pricing */}
          {props.product_type == "wholesale" ? (
            <>
              {/* First Price Range */}
              <div className="row">
                {/* Input Range */}
                <div className="input half">
                  <label>Quantity Range</label>
                  <div className="range-input">
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty1range_from
                          ? Math.ceil(props.variant.qty1range_from)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? {
                                  ...variant,
                                  qty1range_from: e.target.value,
                                }
                              : variant,
                          ),
                        )
                      }
                    />
                    <p className="m-0">&nbsp;-&nbsp;</p>
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty1range_to
                          ? Math.ceil(props.variant.qty1range_to)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? { ...variant, qty1range_to: e.target.value }
                              : variant,
                          ),
                        )
                      }
                    />
                  </div>
                </div>

                {/* Price */}
                <div className="input half">
                  <label className="label">Price</label>
                  <input
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0.0"
                    value={
                      props.variant.qty1range_price
                        ? props.variant.qty1range_price
                        : ""
                    }
                    disabled={show}
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? {
                                ...variant,
                                qty1range_price: e.target.value,
                              }
                            : variant,
                        ),
                      )
                    }
                  />
                </div>
              </div>

              {/* Second Price Range */}
              <div className="row">
                <div className="input half">
                  <label>Quantity Range</label>
                  <div className="range-input">
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty2range_from
                          ? Math.ceil(props.variant.qty2range_from)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? {
                                  ...variant,
                                  qty2range_from: e.target.value,
                                }
                              : variant,
                          ),
                        )
                      }
                    />
                    <p className="m-0">&nbsp;-&nbsp;</p>
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty2range_to
                          ? Math.ceil(props.variant.qty2range_to)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? { ...variant, qty2range_to: e.target.value }
                              : variant,
                          ),
                        )
                      }
                    />
                  </div>
                </div>

                <div className="input half">
                  <label className="label">Price</label>
                  <input
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0.0"
                    value={
                      props.variant.qty2range_price
                        ? props.variant.qty2range_price
                        : ""
                    }
                    disabled={show}
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? {
                                ...variant,
                                qty2range_price: e.target.value,
                              }
                            : variant,
                        ),
                      )
                    }
                  />
                </div>
              </div>

              {/* Third Price Range */}
              <div className="row">
                <div className="input half">
                  <label>Quantity Range</label>
                  <div className="range-input">
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty3range_from
                          ? Math.ceil(props.variant.qty3range_from)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? {
                                  ...variant,
                                  qty3range_from: e.target.value,
                                }
                              : variant,
                          ),
                        )
                      }
                    />
                    <p className="m-0">&nbsp;-&nbsp;</p>
                    <input
                      placeholder="0"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min="0"
                      step="1"
                      disabled={show}
                      value={
                        props.variant.qty3range_to
                          ? Math.ceil(props.variant.qty3range_to)
                          : ""
                      }
                      onChange={(e) =>
                        props.set_variants(
                          props.variants.map((variant) =>
                            variant.id === props.variant.id
                              ? { ...variant, qty3range_to: e.target.value }
                              : variant,
                          ),
                        )
                      }
                    />
                  </div>
                </div>

                <div className="input half">
                  <label className="label">Price</label>
                  <input
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0.0"
                    value={
                      props.variant.qty3range_price
                        ? props.variant.qty3range_price
                        : ""
                    }
                    disabled={show}
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? {
                                ...variant,
                                qty3range_price: e.target.value,
                              }
                            : variant,
                        ),
                      )
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                {/* Normal Sale Price */}
                <div className="input half">
                  <label>Price*</label>
                  <input
                    className={`${getClass(
                      props.variant.showError &&
                        (props.variant.price
                          ? props.variant.price.length < 1
                          : true),
                    )}`}
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0.0"
                    value={props.variant.price ? props.variant.price : ""}
                    disabled={show}
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? { ...variant, price: e.target.value }
                            : variant,
                        ),
                      )
                    }
                  />
                  {props.variant.showError &&
                    (props.variant.price
                      ? props.variant.price.length < 1
                      : true) && <div className="error">Required</div>}
                </div>

                <div className="input half">
                  <label>Discounted Price</label>
                  <input
                    className="col-12 input"
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0.0"
                    disabled={show}
                    value={
                      props.variant.discounted_price
                        ? props.variant.discounted_price
                        : ""
                    }
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? { ...variant, discounted_price: e.target.value }
                            : variant,
                        ),
                      )
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="input half">
                  <label>Quantity*</label>
                  <input
                    className={`input col-12 ${getClass(
                      props.variant.showError &&
                        (props.variant.quantity
                          ? props.variant.quantity.length < 1
                          : true),
                    )}`}
                    placeholder="0.0"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    min="0"
                    step="1"
                    disabled={show}
                    value={
                      props.variant.quantity
                        ? Math.ceil(props.variant.quantity)
                        : ""
                    }
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? { ...variant, quantity: e.target.value }
                            : variant,
                        ),
                      )
                    }
                  />
                  {props.variant.showError &&
                    (props.variant.quantity
                      ? props.variant.quantity.length < 1
                      : true) && <div className="error">Required</div>}
                </div>
              </div>
            </>
          )}
        </div>
        {/* Second Column */}
        <div className="col">
          {/* Image */}
          <div className="row">
            <div className="input">
              <label>Featured Image*</label>
              {props.variant.featured_image !== "" && (
                <ImagesGrid
                  name={state}
                  remove={(val, url) => {
                    let resize_urls = [];

                    props.set_variants(
                      props.variants.map((variant) =>
                        variant.id === props.variant.id
                          ? {
                              ...variant,
                              featured_image: "",
                            }
                          : variant,
                      ),
                    );
                    props?.variant?.featured_image_resized &&
                      props?.variant?.featured_image_resized.length > 0 &&
                      // eslint-disable-next-line
                      props?.variant?.featured_image_resized.map((url2) => {
                        if (url.includes("https")) {
                          resize_urls.push(url2);
                        }
                      });
                    props.set_deleted_images({
                      deletedImagesUrl: [
                        ...props.deletedImagesUrl,
                        ...resize_urls,
                        url,
                      ],
                    });
                  }}
                  images={[props.variant.featured_image]}
                />
              )}
              {uploadingSingleImage && (
                <div className="d-flex justify-content-center align-item-center w-100">
                  <ClipLoader color="#000" loading size={20} />
                </div>
              )}

              {props.variant.showError &&
                props.variant.featured_image.length < 1 && (
                  <div className="error">Required</div>
                )}
              {isEditMode &&
                !props.variant.featured_image &&
                !uploadingSingleImage && (
                  <DropzoneInput
                    multiple={false}
                    type={type.IMAGE}
                    value="Click to upload your file"
                    updateSelectedServiceFiles={handleSingleFileChange}
                  />
                )}
            </div>
          </div>

          <div className="row">
            <label>Gallery*</label>

            {openImagesGrid && (
              <Box marginBottom="12px">
                <ImagesGrid
                  name={state}
                  remove={(val, url) => {
                    props.set_deleted_images({
                      deletedImagesUrl: [...props.deletedImagesUrl, url],
                    });
                    props.set_variants(
                      props.variants.map((variant) =>
                        variant.id === props.variant.id
                          ? {
                              ...variant,
                              images: val,
                            }
                          : variant,
                      ),
                    );
                  }}
                  images={props.variant.images}
                />
              </Box>
            )}
            {uploadingImages && (
              <div className="d-flex justify-content-center align-item-center w-100">
                <ClipLoader color="#000" loading size={20} />
              </div>
            )}

            {props.variant.showError && props.variant.images.length < 1 && (
              <div className="error">Required</div>
            )}
            {isEditMode && !uploadingImages && (
              <Box width="100%">
                <DropzoneInput
                  type={type.IMAGE}
                  value="Click to upload your files"
                  updateSelectedServiceFiles={handleFilesChange}
                />
              </Box>
            )}
          </div>

          {/* Min Order Qty */}
          <div className="row">
            <div className="input">
              <label>Min. order quantity</label>
              <input
                placeholder="0.0"
                type="number"
                onWheel={(e) => e.target.blur()}
                min="0"
                step="1"
                disabled={show}
                value={props.variant.moq ? Math.ceil(props.variant.moq) : ""}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, moq: e.target.value }
                        : variant,
                    ),
                  )
                }
              />
            </div>
          </div>

          {/* Variation */}
          <div className="row">
            <div className="input">
              <label>Variation*</label>
              <input
                className={` ${getClass(
                  props.variant.showError && props.variant.variation.length < 1,
                )}`}
                placeholder="variation"
                type="text"
                disabled={show}
                value={props.variant.variation}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, variation: e.target.value }
                        : variant,
                    ),
                  )
                }
              />

              {props.variant.showError &&
                props.variant.variation.length < 1 && (
                  <div className="error">Required</div>
                )}
            </div>
          </div>

          {/* SKU */}
          <div className="row">
            <div className="input">
              <label>Sku*</label>

              <input
                className={`${getClass(
                  props.variant.showError &&
                    (props.variant.sku ? props.variant.sku.length < 1 : true),
                )}`}
                placeholder="sku"
                type="text"
                disabled={show}
                value={props.variant.sku ? props.variant.sku : ""}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, sku: e.target.value }
                        : variant,
                    ),
                  )
                }
              />
              {props.variant.showError &&
                (props.variant.sku ? props.variant.sku.length < 1 : true) && (
                  <div className="error">Required</div>
                )}
            </div>
          </div>

          {/* UPC */}
          <div className="row">
            <div className="input">
              <label>UPC Code</label>
              <input
                placeholder="UPC"
                type="text"
                disabled={show}
                value={props.variant.upc_code ? props.variant.upc_code : ""}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, upc_code: e.target.value }
                        : variant,
                    ),
                  )
                }
              />
            </div>
          </div>

          {/*  Weight */}
          <div className="row">
            <div className="input">
              <label className="">Weight*</label>
              <input
                className={` ${getClass(
                  props.variant.showError &&
                    (props.variant.weight
                      ? props.variant.weight.length < 1
                      : true),
                )}`}
                placeholder="0.0"
                type="text"
                disabled={show}
                value={props.variant.weight ? props.variant.weight : ""}
                onChange={(e) =>
                  props.set_variants(
                    props.variants.map((variant) =>
                      variant.id === props.variant.id
                        ? { ...variant, weight: e.target.value }
                        : variant,
                    ),
                  )
                }
              />

              {props.variant.showError &&
                (props.variant.weight
                  ? props.variant.weight.length < 1
                  : true) && <div className="error">Required</div>}
            </div>
          </div>

          {/* View In Room */}
          <div className="row">
            <div className="input">
              <FormControlLabel
                control={
                  <Switch
                    onChange={(e) =>
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? { ...variant, enable_3d_image: e.target.checked }
                            : variant,
                        ),
                      )
                    }
                    checked={
                      props.variant.enable_3d_image
                        ? props.variant.enable_3d_image
                        : false
                    }
                    disabled={show}
                  />
                }
                label={<label>Enable View in your Room</label>}
              />
            </div>
          </div>

          {props.variant.enable_3d_image && (
            <>
              <div className="english-col row gx-0">
                <div className="label col-2"></div>
                <div className="d-flex col-12">
                  <div className="col-12 mt-2">
                    {loading && (
                      <div className="d-flex justify-content-center mb-2 align-item-center w-100">
                        <ClipLoader color="#000" loading size={20} />
                      </div>
                    )}
                    {props.variant.android_3d_image && (
                      <div style={{ marginLeft: "220px" }}>
                        <model-viewer
                          src={props.variant.android_3d_image}
                          alt="Android 3D Preview"
                          auto-rotate
                          camera-controls
                          style={{
                            width: "150px",
                            height: "150px",
                            marginBottom: "10px",
                          }}
                        />
                      </div>
                    )}
                    {isEditMode && (
                      <DropzoneInput
                        type=".gltf"
                        value="Click to select 3D image (.gltf)"
                        updateSelectedServiceFiles={async (files) => {
                          try {
                            setLoading(true);
                            const uploaded = await FileUploadPromise(files[0]);
                            props.set_variants(
                              props.variants.map((variant) =>
                                variant.id === props.variant.id
                                  ? {
                                      ...variant,
                                      android_3d_image: uploaded.location,
                                    }
                                  : variant,
                              ),
                            );
                          } catch (error) {
                            message = "File upload error";
                            showError();
                          } finally {
                            setLoading(false);
                          }
                        }}
                      />
                    )}
                    {props.variant.showError &&
                      !props.variant.android_3d_image && (
                        <div
                          className="error mt-2"
                          style={{ width: "70%", margin: "auto" }}
                        >
                          Required
                        </div>
                      )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="input">
                  <label>3D Image Placement*</label>

                  <RSelect
                    isDisabled={show}
                    name="image_placement"
                    value={
                      placements.find(
                        (placement) =>
                          placement.value === props.variant.image_placement,
                      ) || placements[0]
                    }
                    onChange={(option) => {
                      props.set_variants(
                        props.variants.map((variant) =>
                          variant.id === props.variant.id
                            ? { ...variant, image_placement: option.value }
                            : variant,
                        ),
                      );
                    }}
                    options={placements}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />

                  {props.variant.showError &&
                    (props.variant.weight
                      ? props.variant.weight.length < 1
                      : true) && <div className="error">Required</div>}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    variants: state.product.variants,
    deletedImagesUrl: state.product.deletedImagesUrl,
  };
};

const mapDispatchToProps = { set_variants, set_deleted_images };

export default connect(mapStateToProps, mapDispatchToProps)(VariantCard);
